import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const PrivateRoute = ({ children }) => {
  const { customer } = useAuth();

  return customer?.email ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
